import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://keycloak-rp.westeurope.cloudapp.azure.com/',
  realm: 'layout',
  clientId: 'layout-frontend',
});

export default keycloak;